import { useEffect } from 'react'

import { useOpenStageTileContent } from '@/containers/HomeTabPage/hooks/useOpenStageTileContent'
import useStore from '@/store/useStore'
import { StageSlide } from '@/types/servicesTypes/configTypes'

type Props = {
  activeStageSlide?: StageSlide
  isBlockedStage?: boolean
  autoFullscreenTimout?: number
  isEnabled: boolean
}

export const useStageAutoAction = ({
  activeStageSlide,
  isBlockedStage,
  autoFullscreenTimout,
  isEnabled,
}: Props) => {
  const { isDisabledStageAutoslide } = useStore(
    (state) => state.common.appSettings,
  )
  const isFullscreen = useStore((state) => state.player.isFullscreen)

  const openStageTileContent = useOpenStageTileContent()

  useEffect(() => {
    const isAvailable =
      activeStageSlide?.type !== 'Channel' ||
      (!isBlockedStage && activeStageSlide?.channel?.watchable)
    if (
      !activeStageSlide ||
      isDisabledStageAutoslide ||
      !autoFullscreenTimout ||
      !isAvailable ||
      isFullscreen ||
      // !isVideoStarted ||
      !isEnabled
    ) {
      return
    }

    const timerId = setTimeout(() => {
      openStageTileContent(activeStageSlide)
    }, autoFullscreenTimout * 1000)

    return () => {
      clearTimeout(timerId)
    }
  }, [
    activeStageSlide,
    isFullscreen,
    isBlockedStage,
    isDisabledStageAutoslide,
    autoFullscreenTimout,
    openStageTileContent,
    isEnabled,
  ])
}
